import { render } from "./BigStepper.vue?vue&type=template&id=c256d26e&scoped=true"
import script from "./BigStepper.vue?vue&type=script&lang=js"
export * from "./BigStepper.vue?vue&type=script&lang=js"

import "./BigStepper.vue?vue&type=style&index=0&id=c256d26e&scoped=true&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c256d26e"]])

export default __exports__